import { useState } from 'react';
import { getSuggestedLoginsV2, getDirectReportsByManagerLogin } from 'src/utilities/papiAPIs';

export const useSuggestedLogins = () => {
    const [suggestedLogins, setSuggestedLogins] = useState([]);
    const [aliasesLoading, setAliasesLoading] = useState(false);

     const getSuggestedLoginsCaller  = async (fragment, size = 10, addDefault = false) => {
        setSuggestedLogins([]);
        setAliasesLoading(true);
        let costCenters = ["8300", "8308", "8301", "8302", "7982", "8303", "8305", "8310", "8318", "8314", "8340", "8105"];
        try {
            let suggestions = await getSuggestedLoginsV2(fragment, size, costCenters);
            suggestions = suggestions.map((login) => ({
                label: login?.toLowerCase(),
                value: login?.toLowerCase()
            }));
            if (addDefault) {
                suggestions.push(
                    {
                        label: `Default`,
                        value: ``
                    }
                )
            }

            setSuggestedLogins(suggestions);
            setAliasesLoading(false);
            return suggestions;
        } catch (error) {
            console.error('Error fetching suggested logins:', error);
            setSuggestedLogins([]);
            setAliasesLoading(false);
            return [];
        }
    };

    return {
        suggestedLogins,
        aliasesLoading,
        getSuggestedLoginsCaller
    };
};

export const useDirectReports = () => {
    const [directReports, setDirectReports] = useState([]);
    const [directReportsLoading, setDirectReportsLoading] = useState(false);

    const getDirectReportsCaller = async (managerLogin, size = 100) => {
        if (!managerLogin) {
            console.warn('Manager login is required to fetch direct reports');
            setDirectReports([]);
            return [];
        }

        setDirectReports([]);
        setDirectReportsLoading(true);
        const costCenters = ["8300", "8308", "8301", "8302", "7982", "8303", "8305", "8310", "8318", "8314", "8340", "8105"];
        try {
            let reports = await getDirectReportsByManagerLogin(managerLogin, size, costCenters);
            reports = reports.map((login) => ({
                label: login?.toLowerCase(),
                value: login?.toLowerCase()
            }));
            reports.push(
                {
                    label: managerLogin?.toLowerCase(),
                    value: managerLogin?.toLowerCase()
                }
            )
            setDirectReports(reports);
            setDirectReportsLoading(false);
            return reports;
        } catch (error) {
            console.error('Error fetching direct reports:', error);
            setDirectReports([]);
            setDirectReportsLoading(false);
            return [];
        }
    };

    return {
        directReports,
        directReportsLoading,
        getDirectReportsCaller
    };
};
